module.exports = __webpack_public_path__ + "ae0547b2fa629b52e9e040e382faffdf.woff2";